import { Box, Checkbox, FormControlLabel, Grid, TextField, Typography } from '@material-ui/core';
import { FieldArray, useField } from 'formik';
import React, { useEffect } from 'react';
import { get } from 'lodash';
import { BlanketFormFieldOption } from '../../blanketForm/BlanketFormConstants';

import { useStyles } from './RenderCheckboxStyles';

interface RenderMarketingFeeItemsProps {
  name: string;
  label: string;
  options: BlanketFormFieldOption[];
  readOnly?: boolean;
}

const RenderMarketingFeeItems = ({
  name,
  label,
  options,
  readOnly,
}: RenderMarketingFeeItemsProps) => {
  const [field, meta, helper] = useField(name);

  useEffect(() => {
    if (!readOnly && !field.value) {
      const checked = options.filter((o) => o.checked);
      helper.setValue(checked);
    }
  }, []);

  const isChecked = (title: string) => {
    return field.value?.some((item: any) => item.title === title) || false;
  };

  const classes = useStyles();
  return (
    <Box display="flex" flexDirection="column" width="100%">
      <Typography variant="body2" className={classes.subSectionHeader}>
        {label}
      </Typography>
      <Grid container spacing={2} className={classes.marketingFeeContainer}>
        <FieldArray
          name={name}
          render={({ push, remove, form: { values } }) => (
            <>
              {options.map((option) => {
                return (
                  <Grid item xs={12} md={6}>
                    <Box display="flex" justifyContent="space-between">
                      <FormControlLabel
                        labelPlacement="end"
                        className={classes.width100}
                        classes={{
                          label: classes.width100,
                        }}
                        control={
                          <Checkbox
                            color="primary"
                            checked={isChecked(option.title!)} // Updated here
                            disabled={option.disabled || readOnly}
                            onChange={(e) => {
                              if (e.target.checked) {
                                // Prevent duplicate entries
                                if (!isChecked(option.title!)) {
                                  push(option); // Updated here
                                }
                              } else {
                                const idx = get(values, name)
                                  .map((item: any) => item.title)
                                  .indexOf(option.title);
                                if (idx !== -1) {
                                  remove(idx);
                                }
                              }
                            }}
                            id={`${name}${option.title}`}
                          />
                        }
                        label={
                          <Box display="flex" justifyContent="space-between" width="100%">
                            <Box display="flex" flexDirection="column">
                              <Typography>{option.title || ''}</Typography>
                              <Typography className={classes.fontWeight100}>
                                <div dangerouslySetInnerHTML={{ __html: option.subtitle || '' }} />
                              </Typography>
                            </Box>
                            {!option.editable && (
                              <Typography className={classes.checkboxOption}>
                                {option.amount || ''}
                              </Typography>
                            )}
                            {option.editable && (
                              <TextField
                                className={classes.checkboxOption}
                                value={
                                  field.value?.find((item: any) => item.title === option.title)
                                    ?.amount || ''
                                }
                                disabled={readOnly}
                                onChange={(e) => {
                                  const updatedAmount = e.target.value;

                                  const selectedValues = [...field.value];
                                  const idx = selectedValues.findIndex(
                                    (item: any) => item.title === option.title,
                                  );

                                  if (idx !== -1) {
                                    // update only if checked
                                    selectedValues[idx] = {
                                      ...selectedValues[idx],
                                      amount: updatedAmount,
                                    };

                                    helper.setValue(selectedValues);
                                  }
                                }}
                              />
                            )}
                          </Box>
                        }
                      />
                    </Box>
                  </Grid>
                );
              })}
            </>
          )}
        />
      </Grid>
    </Box>
  );
};

export default RenderMarketingFeeItems;
